import React, { useEffect, useState } from "react";
import "./RecentSales.css";
import { Icon } from "@iconify/react";
import { firestoredb, getmapdata } from "../../firebase/firebase";
import { collection, getDocs, where, query } from "firebase/firestore";


function RecentSales(props) {
  const [recentSold, setRecentSold] = useState([]);

  const recentSales = [
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
  ];

  const getMapData1 = async () => {
    const mapdata = await getmapdata();

    // const citiesRef = collection(firestoredb, "map");
    // const q = query(citiesRef, where("bought", "==", true));

    // const querySnapshot = await getDocs(q);
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   console.log(doc.id, " => ", doc.data());
    // });


    mapdata.map((item, index) => {
      const key = Object.keys(item.mapdata)
      key.map((i, index) => {
        const value = item.mapdata[i]
        if (value.bought == true) {
          console.log(i);
          setRecentSold(prev => [...prev, { cordinate: i, value }])
        }
      })

      // console.log(value)
      // console.log(key)
    })
    // setAllSquares(mapdata);
  };

  useEffect(() => {
    getMapData1();
  }, []);
  useEffect(() => {
    console.log(recentSold);
  }, [recentSold]);

  return (
    <div>
      <div className="inventory">
        <div className="inventory-content">
        <button className={`"d-flex align-items-center justify-content-center" ${props.hide}`}>
            <Icon
              icon="ion:chevron-back"
              color="white"
              width="30"
              height="25"
            />
            BACK
          </button>
          <div className="head-and-para">
            <div className="left">

              <h1>{props.head}</h1>
              <p>({recentSold.length})</p>
            </div>
            <div className="right">
              <button>See More..</button>
            </div>
          </div>
          <div className="card-abba">
            {recentSold.map((item, index) => {
              const imageHtml = item.value?.background.split("(")
              if (index < 8) {
                return (
                  <div className="card">
                    <div className="card-header">
                      <img
                        src={imageHtml[1]}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="card-body">
                      <div className="name">
                        <h1>{item.value.name}</h1>
                        <p>LAND</p>
                      </div>
                      <div className="location mt-3">
                        <p className="para ">Gold Smith</p>
                        <p className="para ">
                          <p className="para d-flex ">
                            <img
                              src="\assets\images\Account-setting\locationIcon.svg"
                              alt="land"
                              className="1mg-100"
                            />
                            <span className="text-light-green mx-2">{item.cordinate}</span>
                          </p>
                        </p>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentSales;
